import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import AutoSuggestField from "@FormElements/AutoSuggestField";
import FormContext from "formContext";

function JobTitleAutoSuggestField({intl, settings, ...rest}) {
  const {additionalData, currentStep, setFormData, formData, setErrors} = useContext(FormContext);

  if (!formData || !formData[currentStep] || formData[currentStep] && !formData[currentStep]['specialism']) {
    return '';
  }

  let jobTypes = [];
  additionalData.specialisms && Object.values(additionalData.specialisms.Specialisms).forEach(specialism => {
    if (specialism.Name === formData[currentStep]['specialism']) {
      jobTypes = specialism.lstJobTitles;
    }
  });
  if (jobTypes.length === 0) {
    return '';
  }

  let jobTypeOptions = [];
  let jobTypesFiltered = [];
  if (jobTypes) {
    jobTypeOptions = Object.values(jobTypes).map(function(object) {
      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        const match = object.JobTitleValue.toLowerCase().indexOf(formValue.toLowerCase()) !== -1;

        if (match) {
          jobTypesFiltered.push(object.JobTitleValue);
        }
      }
      return '';
    })
  }

  if (jobTypesFiltered.length > 0) {
    settings.options = jobTypesFiltered;
  } else {
    settings.options = [];
  }

  rest.onChange = e => {
    const {value} = e.target;
    setErrors();
    const match = jobTypes.find(el => el.JobTitleValue === value);

    if (match) {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
        }
        prev[currentStep][settings.name] = match.JobTitleValue;
        prev[currentStep]['job_title_id'] = match.JobTitleCode;
        return {
          ...prev
        }
      });
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        delete prev[currentStep]['job_title_id'];
        return {
          ...prev
        }
      });
    }
  };

  return (
    <AutoSuggestField
      settings={settings}
      {...rest}
    />
  );
}

export default injectIntl(JobTitleAutoSuggestField);
